import { Outlet } from "@clairejs/react-web";
import styled from "styled-components";
import { useLanguage } from "@clairejs/react";

import CustomSuspense from "../../components/custom-suspense";

import Header from "./header";
import Footer from "./footer";

const Wrapper = styled.div`
    flex: 1;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;

    .div-wrapper {
        width: 100%;
        max-width: 1368px;
        padding: 0px 55px;
        box-sizing: border-box;
    }

    @media screen and (max-width: 480px) {
        .div-wrapper {
            padding: 0px 34px;
        }
    }
`;

function Home() {
    useLanguage();

    return (
        <Wrapper>
            <Header />
            <div className="div-wrapper">
                <CustomSuspense>
                    <Outlet />
                </CustomSuspense>
            </div>
            <div className="div-wrapper">
                <Footer />
            </div>
        </Wrapper>
    );
}

export default Home;
